import {
    APPEND_ANALYTICS_EVENTS,
    APPEND_ANALYTICS_USER_FLOW,
    RESET_ANALYTICS,
    SET_ANALYTICS_DATE_RANGE,
    SET_ANALYTICS_EVENT_CATEGORIES,
    SET_ANALYTICS_EVENT_CATEGORIES_ERROR,
    SET_ANALYTICS_EVENT_CATEGORIES_LOADING,
    SET_ANALYTICS_EVENTS,
    SET_ANALYTICS_EVENTS_ERROR,
    SET_ANALYTICS_EVENTS_LOADING,
    SET_ANALYTICS_EVENTS_NEXT_TOKEN,
    SET_ANALYTICS_FILTERS,
    SET_ANALYTICS_KNOWN_PAYLOAD_KEYS,
    SET_ANALYTICS_PAYLOAD_KEYS_LOADING,
    SET_ANALYTICS_PLATFORM_ERROR,
    SET_ANALYTICS_PLATFORM_LOADING,
    SET_ANALYTICS_PLATFORM_STATS,
    SET_ANALYTICS_SUMMARY,
    SET_ANALYTICS_SUMMARY_ERROR,
    SET_ANALYTICS_SUMMARY_LOADING,
    SET_ANALYTICS_TOP_EVENTS,
    SET_ANALYTICS_TOP_EVENTS_ERROR,
    SET_ANALYTICS_TOP_EVENTS_LOADING,
    SET_ANALYTICS_USER_FLOW,
    SET_ANALYTICS_USER_FLOW_ERROR,
    SET_ANALYTICS_USER_FLOW_LOADING,
    SET_ANALYTICS_USER_FLOW_NEXT_TOKEN,
    SET_ANALYTICS_VOLUME,
    SET_ANALYTICS_VOLUME_ERROR,
    SET_ANALYTICS_VOLUME_LOADING,
} from "../constants";

const initialState = {
    dateRange: {
        preset: "30d",
        dateFrom: null,
        dateTo: null,
    },
    filters: {
        eventName: "",
        eventCategory: "",
        platform: "",
        userID: "",
        payloadKey: "",
        payloadValue: "",
    },
    summary: null,
    summaryLoading: false,
    summaryError: null,
    events: [],
    eventsNextToken: null,
    eventsLoading: false,
    eventsError: null,
    topEvents: [],
    topEventsLoading: false,
    topEventsError: null,
    eventCategories: [],
    eventCategoriesLoading: false,
    eventCategoriesError: null,
    volumeOverTime: [],
    volumeLoading: false,
    volumeError: null,
    platformStats: null,
    platformLoading: false,
    platformError: null,
    knownPayloadKeys: [],
    payloadKeysLoading: false,
    userFlow: [],
    userFlowNextToken: null,
    userFlowLoading: false,
    userFlowError: null,
};

const analyticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ANALYTICS_DATE_RANGE:
            return { ...state, dateRange: { ...state.dateRange, ...action.payload } };

        case SET_ANALYTICS_FILTERS:
            return { ...state, filters: { ...state.filters, ...action.payload } };

        case SET_ANALYTICS_SUMMARY:
            return { ...state, summary: action.payload, summaryError: null };
        case SET_ANALYTICS_SUMMARY_LOADING:
            return { ...state, summaryLoading: action.payload };
        case SET_ANALYTICS_SUMMARY_ERROR:
            return { ...state, summaryError: action.payload, summary: null };

        case SET_ANALYTICS_EVENTS:
            return { ...state, events: action.payload, eventsError: null };
        case APPEND_ANALYTICS_EVENTS:
            return { ...state, events: [...state.events, ...action.payload] };
        case SET_ANALYTICS_EVENTS_NEXT_TOKEN:
            return { ...state, eventsNextToken: action.payload };
        case SET_ANALYTICS_EVENTS_LOADING:
            return { ...state, eventsLoading: action.payload };
        case SET_ANALYTICS_EVENTS_ERROR:
            return { ...state, eventsError: action.payload };

        case SET_ANALYTICS_TOP_EVENTS:
            return { ...state, topEvents: action.payload, topEventsError: null };
        case SET_ANALYTICS_TOP_EVENTS_LOADING:
            return { ...state, topEventsLoading: action.payload };
        case SET_ANALYTICS_TOP_EVENTS_ERROR:
            return { ...state, topEventsError: action.payload };

        case SET_ANALYTICS_EVENT_CATEGORIES:
            return { ...state, eventCategories: action.payload, eventCategoriesError: null };
        case SET_ANALYTICS_EVENT_CATEGORIES_LOADING:
            return { ...state, eventCategoriesLoading: action.payload };
        case SET_ANALYTICS_EVENT_CATEGORIES_ERROR:
            return { ...state, eventCategoriesError: action.payload };

        case SET_ANALYTICS_VOLUME:
            return { ...state, volumeOverTime: action.payload, volumeError: null };
        case SET_ANALYTICS_VOLUME_LOADING:
            return { ...state, volumeLoading: action.payload };
        case SET_ANALYTICS_VOLUME_ERROR:
            return { ...state, volumeError: action.payload };

        case SET_ANALYTICS_PLATFORM_STATS:
            return { ...state, platformStats: action.payload, platformError: null };
        case SET_ANALYTICS_PLATFORM_LOADING:
            return { ...state, platformLoading: action.payload };
        case SET_ANALYTICS_PLATFORM_ERROR:
            return { ...state, platformError: action.payload };

        case SET_ANALYTICS_KNOWN_PAYLOAD_KEYS:
            return { ...state, knownPayloadKeys: action.payload };
        case SET_ANALYTICS_PAYLOAD_KEYS_LOADING:
            return { ...state, payloadKeysLoading: action.payload };

        case SET_ANALYTICS_USER_FLOW:
            return { ...state, userFlow: action.payload, userFlowError: null };
        case APPEND_ANALYTICS_USER_FLOW:
            return { ...state, userFlow: [...state.userFlow, ...action.payload] };
        case SET_ANALYTICS_USER_FLOW_NEXT_TOKEN:
            return { ...state, userFlowNextToken: action.payload };
        case SET_ANALYTICS_USER_FLOW_LOADING:
            return { ...state, userFlowLoading: action.payload };
        case SET_ANALYTICS_USER_FLOW_ERROR:
            return { ...state, userFlowError: action.payload };

        case RESET_ANALYTICS:
            return initialState;

        default:
            return state;
    }
};

export default analyticsReducer;
